<template>
  <div id="app">
    <router-view />
    <CookieBanner />
  </div>
</template>

<script>
import CookieBanner from '@/components/CookieBanner.vue'

export default {
  name: 'App',
  components: { CookieBanner }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scrollbar-gutter: stable;
}

        body {
            font-family: 'Inter', sans-serif;
            line-height: 1.65;
            color: #2c3e50;
            overflow-x: hidden;
            font-size: 16px;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }

        /* Typography rhythm */
        p {
            margin: 0 0 1rem;
        }

        ul, ol {
            margin: 0 0 1rem 1.25rem;
        }

        h1, h2, h3, h4, h5, h6 {
            letter-spacing: -0.02em;
        }

        h1, h2, h3 {
            margin-bottom: 0.75rem;
        }

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

        /* Header */
        .header {
            background: rgba(255, 255, 255, 0.95);
            color: #2c3e50;
            padding: 1rem 0;
            position: fixed;
            width: 100%;
            top: 0;
            z-index: 1000;
            backdrop-filter: blur(20px);
            box-shadow: 0 2px 30px rgba(0,0,0,0.08);
            border-bottom: 1px solid rgba(0,0,0,0.05);
        }

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

        .logo {
            font-size: 1.5rem;
            font-weight: 700;
            text-decoration: none;
            color: #2c3e50;
            transition: color 0.3s ease;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
        
        .logo:hover {
            color: #e74c3c;
        }

        .logo-image {
            height: 50px;
            width: auto;
            object-fit: contain;
        }

        .logo-text {
            font-size: 1.5rem;
            font-weight: 700;
            color: #2c3e50;
            margin-left: 0.5rem;
        }

.nav-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
}

        .nav-menu a {
            color: #2c3e50;
            text-decoration: none;
            font-weight: 500;
            transition: all 0.3s ease;
            position: relative;
            padding: 0.5rem 0;
        }

        .nav-menu a:hover {
            color: #e74c3c;
        }

        .nav-menu a::after {
            content: '';
            position: absolute;
            width: 0;
            height: 2px;
            bottom: 0;
            left: 0;
            background-color: #e74c3c;
            transition: width 0.3s ease;
        }

        .nav-menu a:hover::after,
        .nav-menu a.active::after {
            width: 100%;
        }

        .nav-menu a.active {
            color: #e74c3c;
        }

        .cta-button {
            background: #e74c3c;
            color: white;
            padding: 12px 24px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            text-decoration: none;
            transition: all 0.3s ease;
            box-shadow: 0 2px 10px rgba(231, 76, 60, 0.2);
        }

        .cta-button:hover {
            background: #c0392b;
            transform: translateY(-1px);
            box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);
        }

        /* Hero Section */
        .hero {
            background: #ffffff;
            color: #2c3e50;
            padding: 120px 0 80px;
            text-align: center;
            position: relative;
            overflow: hidden;
        }

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.hero-eastern {
  position: relative;
  overflow: hidden;
}

.hero-eastern > * {
  position: relative;
  z-index: 1;
}

.hero-eastern::after {
  z-index: 0;
}

        .hero-eastern::after {
            content: '';
            position: absolute;
            inset: 0;
            background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="%23f5f1ef" fill-opacity="1" d="M0,160L60,160C120,160,240,160,360,170.7C480,181,600,203,720,202.7C840,203,960,181,1080,170.7C1200,160,1320,160,1380,160L1440,160L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path></svg>');
            background-repeat: no-repeat;
            background-position: bottom center;
            background-size: cover;
            opacity: 0.6;
            pointer-events: none;
        }

.hero-content {
  position: relative;
  z-index: 2;
}

        .hero h1 {
            font-size: 3rem;
            font-weight: 700;
            margin-bottom: 1.5rem;
            color: #2c3e50;
            line-height: 1.2;
        }

        .hero p {
            font-size: 1.2rem;
            margin-bottom: 2rem;
            color: #6c757d;
            max-width: 700px;
            margin-left: auto;
            margin-right: auto;
            line-height: 1.6;
        }

.hero-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary {
  background: #e74c3c;
  color: white;
  padding: 16px 32px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(231, 76, 60, 0.2);
  font-size: 1.1rem;
  cursor: pointer;
}

.btn-secondary {
  background: transparent;
  color: #e74c3c;
  padding: 16px 32px;
  border: 2px solid #e74c3c;
  border-radius: 6px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 1.1rem;
  cursor: pointer;
}

.btn-primary:hover, .btn-secondary:hover {
  transform: translateY(-1px);
}

.btn-primary:hover {
  background: #c0392b;
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);
}

.btn-secondary:hover {
  background: #e74c3c;
  color: white;
}

        /* Features Section */
        .features {
            padding: 80px 0;
            background: #ffffff;
        }

        .section-title {
            text-align: center;
            font-size: 2.2rem;
            font-weight: 700;
            margin-bottom: 3rem;
            color: #2c3e50;
            line-height: 1.3;
        }

/* Восточный акцент: тонкая красная линия под заголовком секции */
.section-title::after {
  content: "";
  display: block;
  width: 64px;
  height: 3px;
  border-radius: 2px;
  margin: 10px auto 0;
  background: linear-gradient(90deg, #e74c3c, #c0392b);
  opacity: 0.9;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

        .feature-icon {
            font-size: 2.5rem;
            color: #e74c3c;
            margin-bottom: 1rem;
        }

        .feature-card h3 {
            font-size: 1.3rem;
            font-weight: 600;
            margin-bottom: 1rem;
            color: #2c3e50;
        }

        .feature-card p {
            color: #6c757d;
            line-height: 1.6;
        }

        /* Testimonial Section */
        .testimonial {
            padding: 80px 0;
            background: #f8f9fa;
            color: #2c3e50;
            text-align: center;
        }

.testimonial-content {
  max-width: 800px;
  margin: 0 auto;
}

        .testimonial-text {
            font-size: 1.3rem;
            font-style: italic;
            margin-bottom: 2rem;
            line-height: 1.8;
            color: #495057;
        }

        .testimonial-author {
            font-weight: 600;
            font-size: 1.1rem;
            color: #e74c3c;
        }

        /* CTA Section */
        .cta-section {
            padding: 80px 0;
            background: #2c3e50;
            color: white;
            text-align: center;
        }

        .cta-section h2 {
            font-size: 2.2rem;
            margin-bottom: 1rem;
        }

        .cta-section p {
            font-size: 1.1rem;
            margin-bottom: 2rem;
            opacity: 0.9;
            color: #bdc3c7;
        }

        /* Footer */
        .footer {
            background: #34495e;
            color: white;
            padding: 40px 0;
            text-align: center;
        }

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

        .footer-section h3 {
            margin-bottom: 1rem;
            color: #e74c3c;
        }

        .footer-section a {
            color: #bdc3c7;
            text-decoration: none;
            transition: color 0.3s ease;
        }

        .footer-section a:hover {
            color: #e74c3c;
        }

        .footer-bottom {
            border-top: 1px solid #495057;
            padding-top: 2rem;
            margin-top: 2rem;
        }

/* Responsive */
@media (max-width: 768px) {
  .nav-menu {
    display: none;
  }

  .hero h1 {
    font-size: 2.5rem;
  }

  .hero p {
    font-size: 1.1rem;
  }

  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 2rem;
  }
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}

/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}
</style>
